import { ENTITY_NAME } from '@esentai/core/features/parkingWhitelistFilter/consts';

export const RETRY_FETCH = `${ENTITY_NAME}/RETRY_FETCH`;
export const UPDATE_FETCH = `${ENTITY_NAME}/UPDATE`;
